module.exports = __webpack_public_path__ + "img/grass2.9bddc99f.svg";